import { AppState } from './app';
import * as constants from '../constants';
import { addToSSObject } from '../utils/react';
import { SchemaIndustry } from '@repo/legacy-commerce-api';

// We type the payload cast inside each switch case:
export type EcomSchemaActionType = {
  type:
    | typeof constants.FETCHED_INDUSTRIES_BIG5
    | typeof constants.FETCHED_BOOKING_DATES
    | typeof constants.FETCHED_FILTERS
    | typeof constants.FETCHED_INDUSTRIES
    | typeof constants.UPDATE_INDUSTRY_AND_CLEAN_BASKET
    | typeof constants.UPDATE_INDUSTRY;
  payload: any;
};

export const ecommerceSchemaReducer = (state: AppState, action: EcomSchemaActionType) => {
  switch (action.type) {
    case constants.FETCHED_INDUSTRIES_BIG5: {
      let big5Industries: Record<string, SchemaIndustry> = {};
      action.payload.forEach((industry: SchemaIndustry) => {
        big5Industries[industry.id] = industry;
      });
      const industriesByKey: Record<string, SchemaIndustry> = {};
      action.payload.forEach((industry: SchemaIndustry) => {
        if (!state.industriesByKey[industry.id]) {
          industriesByKey[industry.id] = industry;
        }
      });
      return {
        ...state,
        big5Industries: big5Industries,
        industriesByKey: {
          ...state.industriesByKey,
          ...industriesByKey,
        },
      };
    }

    case constants.FETCHED_BOOKING_DATES: {
      return {
        ...state,
        possibleBookingDates: action.payload.data,
      };
    }

    case constants.FETCHED_FILTERS: {
      let objectsByKey = {};
      for (const property in action.payload.data) {
        let obj = {};
        action.payload.data[property].forEach((el) => {
          obj[el.id] = el;
        });

        objectsByKey[property + 'ByKey'] = obj;
      }

      return {
        ...state,
        filters: {
          ...action.payload.data,
          ...objectsByKey,
        },
      };
    }

    case constants.FETCHED_INDUSTRIES: {
      let industriesByKey: Record<string, SchemaIndustry> = {};
      action.payload.forEach((industry: SchemaIndustry) => {
        industriesByKey[industry.id] = industry;
      });
      return {
        ...state,
        industries: action.payload,
        industriesByKey: {
          ...state.industriesByKey,
          ...industriesByKey,
        },
      };
    }

    case constants.UPDATE_INDUSTRY_AND_CLEAN_BASKET: {
      const codeName = '1001_App\\Shop\\Domain\\Exception\\BasketValidationException';
      const codeName2 = '1004_MicroserviceUsageCore\\Domain\\Exception\\ParameterException';
      const newErrors = { ...state.errors };
      newErrors[codeName] && delete newErrors[codeName];
      newErrors[codeName2] && delete newErrors[codeName2];

      const cleanBasket = {
        products: [],
        productsById: {},
        productsByUrn: {},
        productsByUrnDate: {},
        productsByUrnAll: {},
        stats: null,
      };
      addToSSObject('userDataEC', 'industry', action.payload);
      addToSSObject('userDataEC', 'basketProducts', cleanBasket);
      return {
        ...state,
        errors: { ...newErrors },
        userDataEC: {
          ...state.userDataEC,
          industry: action.payload,
          shouldCreateNewBasketJ2: true,
          shouldCreateNewBasketJ1: true,
          basketProducts: { ...cleanBasket },
        },
      };
    }

    case constants.UPDATE_INDUSTRY: {
      const codeName = '1001_App\\Shop\\Domain\\Exception\\BasketValidationException';
      const codeName2 = '1004_MicroserviceUsageCore\\Domain\\Exception\\ParameterException';
      const newErrors = { ...state.errors };
      newErrors[codeName] && delete newErrors[codeName];
      newErrors[codeName2] && delete newErrors[codeName2];

      addToSSObject('userDataEC', 'industry', action.payload);
      return {
        ...state,
        errors: { ...newErrors },
        userDataEC: {
          ...state.userDataEC,
          industry: action.payload,
        },
      };
    }
  }
};
